"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _apartment = require("@/types/apartment");
var _vuePropertyDecorator = require("vue-property-decorator");
var _ApartmentStatusLabel = _interopRequireDefault(require("./ApartmentStatusLabel.vue"));
var ApartmentTable = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(ApartmentTable, _Vue);
  var _super = (0, _createSuper2.default)(ApartmentTable);
  function ApartmentTable() {
    var _this;
    (0, _classCallCheck2.default)(this, ApartmentTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "apartments", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loading", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "ApartmentStatusTrans", _apartment.ApartmentStatusTrans);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "ApartmentStatus", _apartment.ApartmentStatus);
    return _this;
  }
  (0, _createClass2.default)(ApartmentTable, [{
    key: "rowClick",
    value: function rowClick(row) {
      return row;
    }
  }]);
  return ApartmentTable;
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ApartmentTable.prototype, "apartments", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ApartmentTable.prototype, "loading", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Emit)("row-click")], ApartmentTable.prototype, "rowClick", null);
ApartmentTable = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    ApartmentStatusLabel: _ApartmentStatusLabel.default
  }
})], ApartmentTable);
var _default = ApartmentTable;
exports.default = _default;